import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Ionicon from 'react-ionicons';
import styles from './styles';
import Button from '@material-ui/core/Button';
import swal from 'sweetalert2';

// Custom Components
import LoginBlock from '../../components/LoginBlock';

class More extends Component {
  state = {};

  _handleViewFAQ = () => {
    this.props.changePage('/faqs');
  };

  _handleViewTerms = () => {
    this.props.changePage('/terms');
  };

  _handleViewPrivacyPolicy = () => {
    this.props.changePage('/privacy');
  };

  _handleExportData = () => {
    this.props.changePage('/exports');
  };

  render() {
    const { loggedIn, classes } = this.props;

    if (!loggedIn) {
      return <LoginBlock />;
    }

    return (
      <Grid container className={classes.root} spacing={0}>
        <Grid item xs={12} className={classes.moreContainer}>
          <h1 className={classes.title}>More Information</h1>

          <div style={{ height: 50 }} />

          <Button
            variant="raised"
            color="primary"
            onClick={this._handleViewFAQ}
            className={classes.button}>
            Frequently Asked Questions
          </Button>

          <div style={{ height: 20 }} />

          <Button
            variant="raised"
            color="primary"
            onClick={this._handleViewTerms}
            className={classes.button}>
            Terms & Conditions
          </Button>

          <div style={{ height: 20 }} />

          <Button
            variant="raised"
            color="primary"
            onClick={this._handleViewPrivacyPolicy}
            className={classes.button}>
            Privacy Policy
          </Button>

          <div style={{ height: 20 }} />

          <Button
            variant="raised"
            color="primary"
            onClick={this._handleExportData}
            className={classes.button}>
            Export Donation Report
          </Button>
        </Grid>
      </Grid>
    );
  }
}

More = withStyles(styles)(More);

const mapStateToProps = state => ({
  loggedIn: state.user.loggedIn
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: url => push(url)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(More);



// WEBPACK FOOTER //
// ./src/containers/more/index.js